export const tabTypes = {
  COMPARISON: 'Comparison',
  RESULTS: 'ResultsDetails',
  EXPORT: 'Exporter',
  FREETEXT: 'FreeTextVisualizer'
}
